<template>
  <v-container class="forms-list" max-width="720">
    <h1 class="forms-list__title">Forms</h1>

    <div v-if="status === 'loading'" class="forms-list__state">
      <v-progress-circular indeterminate color="primary" />
      <span class="ml-3">Loading…</span>
    </div>

    <v-alert
      v-else-if="status === 'error'"
      type="error"
      variant="tonal"
    >
      Forms could not be loaded.
      <div class="mt-3">
        <v-btn variant="text" color="primary" class="text-none" @click="load">Retry</v-btn>
      </div>
    </v-alert>

    <v-alert
      v-else-if="forms.length === 0"
      type="info"
      variant="tonal"
    >
      No forms to complete right now.
    </v-alert>

    <v-list v-else class="forms-list__items" lines="two">
      <v-list-item
        v-for="form in forms"
        :key="form.slug"
        :title="form.title"
        :subtitle="form.description || ''"
        @click="fillIn(form.slug)"
      >
        <template #append>
          <div class="forms-list__item-actions">
            <v-btn
              v-if="isAdmin"
              variant="text"
              size="small"
              class="text-none"
              @click.stop="viewSubmissions(form.slug)"
            >
              Submissions
            </v-btn>
            <v-btn
              color="primary"
              variant="flat"
              size="small"
              class="text-none"
              @click.stop="fillIn(form.slug)"
            >
              Fill in
            </v-btn>
          </div>
        </template>
      </v-list-item>
    </v-list>
  </v-container>
</template>

<script>
// FormsList — the employee's landing for Forms: the active forms they can fill.
// Admin-only management (build / submissions) is added in Stage 5.
import { mapStores } from 'pinia'
import FormApi from '@/services/FormApi'
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'FormsList',
  data () {
    return {
      forms: [],
      status: 'loading', // loading | idle | error
    }
  },
  computed: {
    ...mapStores(useAuthStore),
    // Admins additionally get a "Submissions" action per form; the route and the
    // server endpoint are independently admin-gated.
    isAdmin () {
      return this.authStore.isAdmin
    },
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.status = 'loading'
      try {
        const res = await FormApi.list()
        this.forms = (res.data && res.data.forms) || []
        this.status = 'idle'
      } catch (err) {
        this.status = 'error'
      }
    },
    fillIn (slug) {
      this.$router.push({ name: 'form-fill', params: { slug } })
    },
    viewSubmissions (slug) {
      this.$router.push({ name: 'form-submissions', params: { slug } })
    },
  },
}
</script>

<style scoped>
.forms-list {
  padding-top: 16px;
  padding-bottom: 48px;
}

.forms-list__title {
  font-size: 1.6rem;
  font-weight: 800;
  color: #41281b;
  margin-bottom: 16px;
}

.forms-list__state {
  display: flex;
  align-items: center;
  padding: 24px 0;
}

.forms-list__item-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
